export default "<app-subfooter class=\"footer\"></app-subfooter>"